module.exports = __webpack_public_path__ + "img/banners-vaccine_nonsale.2c0ca549.png";